<template>
    <ul class="nav nav-navs swell-settings-nav">
        <slot></slot>
    </ul>
</template>

<script>
    export default {
        created() {
            window.addEventListener('hashchange', () => {
                this.$emit('change', window.location.hash.substring(2));
            });
        },
    };
</script>
